import { useCallback, useEffect } from 'react';
import { MOBILE_SCREEN } from 'consts';
import { useIntersection, useMatchMedia } from 'hooks';
import { setFixedReservationBannerVisible } from 'models/product';

export const useCheckReservationBtnPosition = (
  enquiryWrapperRef,
  mainBtnRef,
  isHiringPossible,
  isNotAvailable,
) => {
  const offsetFromTop = 60;

  const isMobile = useMatchMedia(`(max-width: ${MOBILE_SCREEN}px)`);
  const isEnquiryInViewport = useIntersection(enquiryWrapperRef, '-100px');
  const isMainBtnInViewport = useIntersection(
    mainBtnRef,
    `-${offsetFromTop}px 0px -40px 0px`,
  );

  const handleScroll = useCallback(() => {
    if (
      (!isHiringPossible && isEnquiryInViewport) ||
      isMainBtnInViewport ||
      !isMobile
    ) {
      return;
    }

    //hide bar on the very page bottom
    if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
      setFixedReservationBannerVisible(false);
      return;
    }

    setFixedReservationBannerVisible(true);
  }, [isEnquiryInViewport, isHiringPossible, isMainBtnInViewport, isMobile]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      setFixedReservationBannerVisible(false);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    if (!isMobile) {
      setFixedReservationBannerVisible(false);
      return;
    }

    if (isHiringPossible || isNotAvailable) {
      setFixedReservationBannerVisible(!isMainBtnInViewport);
      return;
    }

    setFixedReservationBannerVisible(
      !isEnquiryInViewport && !isMainBtnInViewport,
    );
  }, [
    isMobile,
    isNotAvailable,
    isEnquiryInViewport,
    isHiringPossible,
    isMainBtnInViewport,
  ]);
};
